import React, { Children, cloneElement, memo, ReactElement } from 'react'
import styled from 'styled-components'

import { CssUnit } from '@/types'

const Wrapper = styled.div<{
  gutter: CssUnit
  top?: CssUnit
  bottom?: CssUnit
}>`
  display: flex;
  flex-wrap: wrap;
  margin-right: -${props => props.gutter}px;
  margin-left: -${props => props.gutter}px;
  margin-top: ${props => props.top}px;
  margin-bottom: ${props => props.bottom}px;
`

interface Props {
  children: React.ReactNode
  gutter?: CssUnit
  top?: CssUnit
  bottom?: CssUnit
}

type ChildrenProps = {
  gutter?: CssUnit
}

const Row: React.FC<Props> = ({ children, gutter = 10, ...rest }) => (
  <Wrapper {...rest} gutter={gutter}>
    {Children.map(
      children,
      child =>
        React.isValidElement(child) &&
        cloneElement(child as ReactElement<ChildrenProps>, {
          gutter: gutter
        })
    )}
  </Wrapper>
)
export default memo(Row)
